<template>
  <div>
    <div class="reappro reappro--mobile" v-if="$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true">
      <ReapproHeader :next="true" :item="this.detail"></ReapproHeader>
      <ProductFamilyList class="categories--reappro"></ProductFamilyList>
      <div class="reappro__products">
        <ProductReappro :item="item" v-for="item in this.detail.lines" :next="true" :key="item.id" :update="true"
          @qt="changeQt(item.id, item.quantity)"></ProductReappro>
      </div>
      <div class="reappro__btns">
        <a href="" class="reappro__btn btn btn--valider" @click.prevent="showModalV = 1">
          <span class="btn__text">Je valide mon prochain réappro</span>
          <img src="/static/img/pictos/valider.svg" class="btn__picto" alt="">
        </a>
        <a href="" class="reappro__btn btn btn--delete" @click.prevent="showModalR = 1">
          <span class="btn__text">Je refuse mon prochain réappro</span>
          <img src="/static/img/pictos/supprimer.svg" class="btn__picto" alt="">
        </a>
      </div>
    </div>
    <ReapproModal v-if="showModalV == 1" @close="showModalV = 0" :type="'valid'" :id="this.detail.id" :item="this.detail">
    </ReapproModal>
    <ReapproModal v-if="showModalR == 1" @close="showModalR = 0" :type="'refuse'" :id="this.detail.id"
      :item="this.detail"></ReapproModal>
  </div>
</template>

<script>

import ReapproHeader from "@/components/Reappro/ReapproHeader";
import ProductFamilyList from "@/components/ProductFamily/ProductFamilyList";
import ProductReappro from "@/components/Product/ProductReappro";
import ReapproModal from "@/components/Reappro/ReapproModal";

export default {
  name: "ReapproNext",
  data() {
    return {
      showModalV: 0,
      showModalR: 0,
      detail: {
        id: null,
      }
    };
  },
  mounted() {
    const self = this;

    this.$store.dispatch("order/getItem", {id: this.$route.params.id}).then(() => {
      this.detail = this.$store.getters["order/getItem"](
        this.$route.params.id
      );
    });
  },
  methods: {
    changeQt(id, qt){
    },
  },
  components: {
    ReapproHeader,
    ProductFamilyList,
    ProductReappro,
    ReapproModal,
  }
};
</script>


<style lang="scss" scoped>
@import "~@/assets/scss/_colors.scss";

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: white;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $grisclair;
  border-radius: 20px;
  height: 5px;
}

.reappro {
  display: flex;

  &--mobile {
    flex-direction: column;

    .reappro__products {
      padding: 20px;
    }

    .imputation__text {
      margin-right: 5px;
    }

    .product {
      .imputation__selector {
        margin-left: 0;
      }
    }
  }
}

.reappro__btns {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: flex-end;
  margin-top: 20px;
  width: 100%;
  position: fixed;
  bottom: 0;
  height: 75px;
  z-index: 19;

  .reappro__btn {
    width: 50%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    height: 75px;
    color: white;
    outline: none;
    border-radius: 0;
    padding: 0 20px;

    img {
      width: 25px;
      margin-left: 5px;
      margin-left: 15px;
    }

    span {
      font-size: 11px;
      font-family: 'ClanPro';
      flex: 1;
      text-align: left;
    }

    &.btn--valider {
      background-color: $vert;
      justify-content: space-between;
      align-items: center;
    }

    &.btn--delete {
      background-color: $color1;
      justify-content: space-between;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Reappro/ReapproNext.vue